<template>
  <div class="print-d" style="margin:auto;">
    <table class="report-table" border="1">
      <tr>
        <td colspan="25">
          <div>
            报名序号：{{data.EnrollNo}}
          </div>
          <div class="center large" style="margin:6px 0;">{{year}}年汕头市金山中学“丘成桐少年班”六年级学生报名信息表</div>
        </td>
      </tr>
      <tr>
        <td class="center" style="width:17%;">姓名</td>
        <td class="center wl" colspan="9" style="width:23.5%;">{{data.FullName}}</td>
        <td class="center" style="width:19%;">性别</td>
        <td class="center wl" colspan="9" style="width:27.5%;">{{data.Sex==1?"男":"女"}}</td>
        <td class="center red bold small" rowspan="5">
          <el-image v-if="!loading" class="photo" :src="'/api'+data.PicUrl" fit="cover" :preview-src-list="['/api'+data.PicUrl]" style="height: 165px;width: 130px;margin-top: 6px;" />
        </td>
      </tr>
      <tr>
        <td class="center">身份证</td>
        <td class="center" colspan="9">{{data.IdCard}}</td>
        <td class="center">户籍地</td>
        <td class="center" colspan="9">{{data.Domicile}}</td>
      </tr>
      <tr>
        <td class="center">出生日期</td>
        <td class="center" colspan="9">{{toDateString(data.BirthDate)}}</td>
        <td class="center small pd-sm">就读小学所在<br class="only-print" />区县</td>
        <td class="center" colspan="9">{{data.SchoolDistrict}}</td>
      </tr>
      <tr>
        <td class="center pd-sm">就读小学</td>
        <td class="center" colspan="19">{{data.PrimarySchool}}</td>
      </tr>
      <tr>
        <td class="center small pd-sm">家长手机号</td>
        <td class="center" colspan="19" style="height:40px;">{{data.Mobile}}</td>
      </tr>
      <tr>
        <td class="center bold">个人特长</td>
        <td class="center lv" style="width:18.25%;">等级</td>
        <td class="center">证书</td>
        <td class="center" colspan="22">表现说明</td>
      </tr>
      <tr>
        <td class="center" style="height:34px;">{{data.SpecialName1}}</td>
        <td class="center">{{data.SpecialLv1}}</td>
        <td class="center pd-sm">
          <el-image v-if="!loading&&data.SpecialCertUrl1" class="zs-img" :src="'/api'+data.SpecialCertUrl1" fit="cover" :preview-src-list="['/api'+data.SpecialCertUrl1]" />
        </td>
        <td class="center" colspan="22">{{data.SpecialRemark1}}</td>
      </tr>
      <tr>
        <td class="center" style="height:34px;">{{data.SpecialName2}}</td>
        <td class="center">{{data.SpecialLv2}}</td>
        <td class="center pd-sm">
          <el-image v-if="!loading&&data.SpecialCertUrl2" class="zs-img" :src="'/api'+data.SpecialCertUrl2" fit="cover" :preview-src-list="['/api'+data.SpecialCertUrl2]" />
        </td>
        <td class="center" colspan="22">{{data.SpecialRemark2}}</td>
      </tr>
      <tr>
        <td class="center bold">竞赛获奖</td>
        <td class="center pd-sm">等级<br/>(区县以上)</td>
        <td class="center">证书</td>
        <td class="center" colspan="22">表现说明</td>
      </tr>
      <tr>
        <td class="center" style="height:34px;">{{data.AwardName1}}</td>
        <td class="center">{{data.AwardLv1}}</td>
        <td class="center pd-sm">
          <el-image v-if="!loading&&data.AwardlCertUrl1" class="zs-img" :src="'/api'+data.AwardlCertUrl1" fit="cover" :preview-src-list="['/api'+data.AwardlCertUrl1]" />
        </td>
        <td class="center" colspan="22">{{data.AwardRemark1}}</td>
      </tr>
      <tr>
        <td class="center" style="height:34px;">{{data.AwardName2}}</td>
        <td class="center">{{data.AwardLv2}}</td>
        <td class="center pd-sm">
          <el-image v-if="!loading&&data.AwardlCertUrl2" class="zs-img" :src="'/api'+data.AwardlCertUrl2" fit="cover" :preview-src-list="['/api'+data.AwardlCertUrl2]" />
        </td>
        <td class="center" colspan="22">{{data.AwardRemark2}}</td>
      </tr>
      <tr>
        <td class="center" rowspan="3">承诺：</td>
        <td class="center" colspan="24">
          我们郑重承诺，以上所填内容完全真实准确。
          <br />否则，愿意承担取消遴选资格或录取资格的后果。
        </td>
      </tr>
      <tr>
        <td class="center pd-sm">家长签名：</td>
        <td class="center bold" colspan="24">
          <el-image v-if="data.ParentSignUrl" :src="'/api'+data.ParentSignUrl" fit="contain" :preview-src-list="['/api'+data.ParentSignUrl]" style="height: 80px;width: 160px;" />
          <span v-else>(确认提交本信息表后，默认家长和考生签名完成!)</span>
        </td>
      </tr>
      <tr>
        <td class="center pd-sm">学生签名：</td>
        <td class="center">
          <el-image v-if="data.StudentSignUrl" :src="'/api'+data.StudentSignUrl" fit="contain" :preview-src-list="['/api'+data.StudentSignUrl]" style="height: 80px;width: 160px;" />
        </td>
        <td class="center" colspan="23" v-if="data.AddTime">{{toYMString(data.AddTime)}}</td>
        <td class="center" colspan="23" v-else>{{year}}年{{month}}月</td>
      </tr>
      <tr>
        <td class="bold" colspan="25">
          <span class="red">特别提示：</span>
          <span class="blue">1、本表打印完成后，须在“电子彩照”位置贴上近期一寸彩照，并完成签名!!</span>
          <div class="blue" style="text-indent:5.3rem;">2、本表于参加遴选时交给现场老师。</div>
        </td>
      </tr>
    </table>
    <div class="handle-button no-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>
<script>
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;

export default {
  beforeMount() {
    this.loading = true;
    var id = this.$route.query.id;
    this.api.info(id).then(res => {
      this.loading = false;
      if(res.Code==0) {
        if(res.Data) this.data = res.Data;
      } else this.$message.error(res.Msg);
    });
  },
  data() {
    return {
      api: require("@/api/po/junior6").default,
      data: {
        Junior6Id: 0,
        ParentId: 0,
        EnrollNo: "",
        FullName: "",
        Sex: null,
        IdCard: "",
        Domicile: "",
        BirthDate: "",
        PrimarySchool: "",
        SchoolDistrict: "",
        Mobile: "",
        //------------
        SpecialName1: "",
        SpecialLv1: "",
        SpecialCertUrl1: "",
        SpecialRemark1: "",
        SpecialName2: "",
        SpecialLv2: "",
        SpecialCertUrl2: "",
        SpecialRemark2: "",
        AwardName1: "",
        AwardLv1: "",
        AwardlCertUrl1: "",
        AwardRemark1: "",
        AwardName2: "",
        AwardLv2: "",
        AwardlCertUrl2: "",
        AwardRemark2: "",
        //------------
        PicUrl: "",
        ParentSignUrl: "",
        StudentSignUrl: "",
        Status: 0,
        AddTime: ","
      },
      loading: false,
      year,
      month,
    };
  },
  methods: {
    toDateString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月" + arr[2] + "日";
    },
    toYMString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月";
    },
    print() {
      window.print();
    }
  }
};
</script>
<style lang="scss" scoped>
.print-d {
  width: 1100px;
  padding: 10px 0;
}
.handle-button {
  position: fixed;
  top: 10px;
  right: 30px;
}
.report-table {
  font-family: "宋体","微软雅黑";
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  td {
    padding: 6px 8px;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .red {
    color: #f11;
  }
  .blue {
    color: #11f;
  }
  .small {
    font-size: 14px;
  }
  .large {
    font-size: 20px;
  }
  .zs-img {
    height: 100px;
    width: 140px;
    margin-top: 6px;
  }
  .only-print {
    display: none;
  }
}
@media print {
  .print-d {
    width: 100%;
    padding: 0;
  }
  .no-print {
    display: none;
  }
  .only-print {
    display: block !important;
  }
  .wl {
    width: 25.5% !important;
  }
  .pd-sm {
    padding: 2px !important;
  }
  .lv {
    width: 21% !important;
  }
  .photo {
    height: 160px !important;
  }
  .zs-img {
    margin-top: 4px !important;
    width: 120px !important;
    height: 80px !important;
  }
}
</style>